import React from 'react';
import { LinkIcon, ExclamationTriangleIcon } from '@heroicons/react/24/solid';
import EmbeddedNotepadNoteCard from './EmbeddedNotepadNoteCard';
import { EmbeddedNotepadSlotSkeleton } from './EmbeddedNotepadSlotSkeleton';

const EmbeddedNotepadNoteSlot = ({
  label,
  noteId,
  note,
  isResolving = false,
  onLink,
  onOpenNote,
  onUnlink,
}) => {
  if (isResolving) {
    return <EmbeddedNotepadSlotSkeleton label={label} />;
  }

  if (!noteId) {
    return (
      <div className="rounded-xl border border-dashed border-gray-300 bg-gray-50/80 p-4">
        <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-500">{label}</p>
        <button
          type="button"
          onClick={onLink}
          className="inline-flex items-center gap-1.5 rounded-lg bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-gray-200 hover:bg-gray-50"
        >
          <LinkIcon className="h-4 w-4 text-gray-500" />
          Link note
        </button>
      </div>
    );
  }

  if (!note) {
    return (
      <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-600">{label}</p>
        <div className="mb-3 flex items-start gap-2 text-sm text-amber-800">
          <ExclamationTriangleIcon className="mt-0.5 h-5 w-5 shrink-0" />
          <span>Linked note not found. It may have been deleted.</span>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={onLink}
            className="inline-flex items-center gap-1.5 rounded-lg bg-amber-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-amber-700"
          >
            <LinkIcon className="h-4 w-4" />
            Relink note
          </button>
          {onUnlink && (
            <button
              type="button"
              onClick={onUnlink}
              className="rounded-lg px-3 py-1.5 text-sm font-medium text-amber-900 hover:bg-amber-100"
            >
              Clear link
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-2 flex items-center justify-between gap-2">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">{label}</p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onLink}
            className="text-xs font-medium text-gray-500 hover:text-gray-700"
          >
            Change
          </button>
          {onUnlink && (
            <button
              type="button"
              onClick={onUnlink}
              className="text-xs font-medium text-gray-500 hover:text-gray-700"
            >
              Unlink
            </button>
          )}
        </div>
      </div>
      <EmbeddedNotepadNoteCard note={note} onClick={() => onOpenNote(note)} />
    </div>
  );
};

export default EmbeddedNotepadNoteSlot;
